import { render, staticRenderFns } from "./UpdateSystem.vue?vue&type=template&id=c648fd18&"
import script from "./UpdateSystem.vue?vue&type=script&lang=js&"
export * from "./UpdateSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports